// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"28":"f9023ec8","108":"2a681c1b","111":"f9023ec8","404":"f9023ec8","417":"7e836c07","768":"f9023ec8"}[chunkId] + ".chunk.css";
};